import { render, staticRenderFns } from "./addIssuer.vue?vue&type=template&id=6d1d45eb&scoped=true&"
import script from "./addIssuer.vue?vue&type=script&lang=js&"
export * from "./addIssuer.vue?vue&type=script&lang=js&"
import style0 from "./addIssuer.vue?vue&type=style&index=0&id=6d1d45eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d45eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1d45eb')) {
      api.createRecord('6d1d45eb', component.options)
    } else {
      api.reload('6d1d45eb', component.options)
    }
    module.hot.accept("./addIssuer.vue?vue&type=template&id=6d1d45eb&scoped=true&", function () {
      api.rerender('6d1d45eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityComment/components/addIssuer.vue"
export default component.exports